export function convertKilobytesToBytes(value: number): number {
  return value * 1000;
}
